import { useFormikContext } from 'formik'
import React, { ReactElement } from 'react'

import { SearchFormState } from '@components/SearchForm'
import StopoverModalButton from '@components/SearchForm/StopOver/ModalField/ModalButton'

const ModalField = (): ReactElement => {
  const { values } = useFormikContext<SearchFormState>()
  const { stopOverStations, viasRules } = values

  return <StopoverModalButton stopoverData={stopOverStations} viasRulesData={viasRules} />
}

export default ModalField
